import { default as _axios } from "axios";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { getToken, getUserContextIds } from "@/utils/sessionStorage";

dayjs.extend(utc);

//@ts-expect-error Not sure
delete Date.prototype.toJSON;

Date.prototype.toJSON = function () {
  return dayjs(this).utc().format("YYYY-MM-DDTHH:mm:ss.000") + "Z";
};

const axios = _axios.create();
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    const ids = getUserContextIds() || {};
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (ids.userId) config.headers["UserId"] = ids.userId;
    if (ids.companyId) config.headers["CompanyId"] = ids.companyId;
    // if (ids.companyId) config.headers["companyId"] = ids.companyId;
    config.headers["SiteId"] = SITE_ID;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const refreshTokenAxios = _axios.create();
refreshTokenAxios.interceptors.request.use(
  (config) => {
    const token = getToken();
    const ids = getUserContextIds() || {};
    config.headers["Content-Type"] = "application/json";
    if (token) {
      config.headers["Authorization"] = token;
    }
    if (ids.userId) config.headers["UserId"] = ids.userId;
    if (ids.companyId) config.headers["CompanyId"] = ids.companyId;
    config.headers["SiteId"] = SITE_ID;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const HOST_REVIVERUSERS = import.meta.env.VITE_HOST_REVIVERUSERS;
const HOST_REVIVERAPPLICATION = import.meta.env.VITE_HOST_REVIVERAPPLICATION;
const HOST_REVIVERCONTRACTS = import.meta.env.VITE_HOST_REVIVERCONTRACTS;
const HOST_REVIVERAUTHENTICATION = import.meta.env.VITE_HOST_REVIVERAUTHENTICATION;
const HOST_REVIVERDOCUMENTARCHIVE = import.meta.env.VITE_HOST_REVIVERDOCUMENTARCHIVE;
const HOST_REVIVERAUCTION = import.meta.env.VITE_HOST_REVIVERAUCTION;
const HOST_REVIVERACCOUNTING = import.meta.env.VITE_HOST_REVIVERACCOUNTING;
const HOST_REVIVERTRANSPORT = import.meta.env.VITE_HOST_REVIVERTRANSPORT;
const HOST_REVIVERMESSAGING = import.meta.env.VITE_HOST_REVIVERMESSAGING;
const HOST_REVIVERTASKS = import.meta.env.VITE_HOST_REVIVERTASKS;
const HOST_REVIVERFEEDBACK = import.meta.env.VITE_HOST_REVIVERFEEDBACK;
const HOST_REVIVERCLAIMS = import.meta.env.VITE_HOST_REVIVERCLAIMS;
const HOST_REVIVERCAMERACONTROL = import.meta.env.VITE_HOST_REVIVERCAMERACONTROL;
const HOST_DEVELOPMENT_MOCK = import.meta.env.VITE_HOST_DEVELOPMENT_MOCK;
const SITE_ID = import.meta.env.VITE_SITE_ID;
const IS_DEV = import.meta.env.NODE_ENV === "development";
const IS_MOCK = !!import.meta.env.VITE_MOCK;
const PROTOCOL = window.location.protocol;

let APIBASE_REVIVERUSERS: string;
let APIBASE_REVIVERAPPLICATION: string;
let APIBASE_REVIVERCONTRACTS: string;
let APIBASE_REVIVERAUTHENTICATION: string;
let APIBASE_REVIVERDOCUMENTARCHIVE: string;
let APIBASE_REVIVERAUCTION: string;
let APIBASE_REVIVERACCOUNTING: string;
let APIBASE_REVIVERTRANSPORT: string;
let APIBASE_REVIVERMESSAGING: string;
let APIBASE_REVIVERTASKS: string;
let APIBASE_REVIVERFEEDBACK: string;
let APIBASE_REVIVERCLAIMS: string;
let APIBASE_REVIVERCAMERACONTROL: string;
const IS_DEV_NOT_MOCK = IS_DEV && !IS_MOCK;

const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

if (isLocalhost && !IS_MOCK) {
  APIBASE_REVIVERAPPLICATION = "/app/";
  APIBASE_REVIVERCONTRACTS = "/con/";
  APIBASE_REVIVERUSERS = "/usr/";
  APIBASE_REVIVERAUTHENTICATION = "/auth/";
  APIBASE_REVIVERDOCUMENTARCHIVE = "/archive/";
  APIBASE_REVIVERAUCTION = "/auc/";
  APIBASE_REVIVERACCOUNTING = "/acc/";
  APIBASE_REVIVERTRANSPORT = "/trans/";
  APIBASE_REVIVERMESSAGING = "/msg/";
  APIBASE_REVIVERTASKS = "/tasks/";
  APIBASE_REVIVERFEEDBACK = "/fb/";
  APIBASE_REVIVERCLAIMS = "/claims/";
  APIBASE_REVIVERCAMERACONTROL = "/camera/";
} else if (IS_DEV && IS_MOCK) {
  const common = `${PROTOCOL}//${HOST_DEVELOPMENT_MOCK}/`;
  APIBASE_REVIVERUSERS = common;
  APIBASE_REVIVERAPPLICATION = common;
  APIBASE_REVIVERCONTRACTS = common;
  APIBASE_REVIVERAUTHENTICATION = common;
  APIBASE_REVIVERDOCUMENTARCHIVE = common;
  APIBASE_REVIVERAUCTION = common;
  APIBASE_REVIVERACCOUNTING = common;
  APIBASE_REVIVERTRANSPORT = common;
  APIBASE_REVIVERMESSAGING = common;
  APIBASE_REVIVERTASKS = common;
  APIBASE_REVIVERFEEDBACK = common;
  APIBASE_REVIVERCLAIMS = common;
  APIBASE_REVIVERCAMERACONTROL = common;
} else if (IS_DEV) {
  APIBASE_REVIVERAPPLICATION = "/app/";
  APIBASE_REVIVERCONTRACTS = "/con/";
  APIBASE_REVIVERUSERS = "/usr/";
  APIBASE_REVIVERAUTHENTICATION = "/auth/";
  APIBASE_REVIVERDOCUMENTARCHIVE = "/archive/";
  APIBASE_REVIVERAUCTION = "/auc/";
  APIBASE_REVIVERACCOUNTING = "/acc/";
  APIBASE_REVIVERTRANSPORT = "/trans/";
  APIBASE_REVIVERMESSAGING = "/msg/";
  APIBASE_REVIVERTASKS = "/tasks/";
  APIBASE_REVIVERFEEDBACK = "/fb/";
  APIBASE_REVIVERCLAIMS = "/claims/";
  APIBASE_REVIVERCAMERACONTROL = "/camera/";
} else {
  APIBASE_REVIVERUSERS = `${PROTOCOL}//${HOST_REVIVERUSERS}/`;
  APIBASE_REVIVERAPPLICATION = `${PROTOCOL}//${HOST_REVIVERAPPLICATION}/`;
  APIBASE_REVIVERCONTRACTS = `${PROTOCOL}//${HOST_REVIVERCONTRACTS}/`;
  APIBASE_REVIVERAUTHENTICATION = `${PROTOCOL}//${HOST_REVIVERAUTHENTICATION}/`;
  APIBASE_REVIVERDOCUMENTARCHIVE = `${PROTOCOL}//${HOST_REVIVERDOCUMENTARCHIVE}/`;
  APIBASE_REVIVERAUCTION = `${PROTOCOL}//${HOST_REVIVERAUCTION}/`;
  APIBASE_REVIVERACCOUNTING = `${PROTOCOL}//${HOST_REVIVERACCOUNTING}/`;
  APIBASE_REVIVERTRANSPORT = `${PROTOCOL}//${HOST_REVIVERTRANSPORT}/`;
  APIBASE_REVIVERMESSAGING = `${PROTOCOL}//${HOST_REVIVERMESSAGING}/`;
  APIBASE_REVIVERTASKS = `${PROTOCOL}//${HOST_REVIVERTASKS}/`;
  APIBASE_REVIVERFEEDBACK = `${PROTOCOL}//${HOST_REVIVERFEEDBACK}/`;
  APIBASE_REVIVERCLAIMS = `${PROTOCOL}//${HOST_REVIVERCLAIMS}/`;
  APIBASE_REVIVERCAMERACONTROL = `${PROTOCOL}//${HOST_REVIVERCAMERACONTROL}/`;
}

export {
  APIBASE_REVIVERUSERS,
  APIBASE_REVIVERAPPLICATION,
  APIBASE_REVIVERCONTRACTS,
  APIBASE_REVIVERAUTHENTICATION,
  APIBASE_REVIVERDOCUMENTARCHIVE,
  APIBASE_REVIVERAUCTION,
  APIBASE_REVIVERACCOUNTING,
  APIBASE_REVIVERTRANSPORT,
  APIBASE_REVIVERMESSAGING,
  APIBASE_REVIVERTASKS,
  APIBASE_REVIVERFEEDBACK,
  APIBASE_REVIVERCLAIMS,
  APIBASE_REVIVERCAMERACONTROL,
  SITE_ID,
  IS_DEV_NOT_MOCK,
  IS_DEV,
  axios,
  refreshTokenAxios,
};
